<template>
    <div>
        <div
            v-if="!isHidden"
            class="green-toggle custom-control custom-switch py-1"
        >
            <input
                type="checkbox"
                class="custom-control-input"
                :id="permission.key"
                :checked="permission.access"
                :value="permission.access"
                @change="onPermissionToggled"
                true-value="1"
                false-value="0"
            />
            <label class="custom-control-label" :for="permission.key">{{
                permission.label
            }}</label>
        </div>
    </div>
</template>
<script>
import EXTENSIONS from "@/constants/extensions";

// NOTE: Hardcoded list of permissions that depend on extension(s)
// REF: ..apps/application/views/staff/business/sub/permission/list.php
const EXTENSIONS_DEPENDENT_PERMISSSIONS = [
    {
        permissionKey: "billing.invoice.sms",
        extensions: [
            EXTENSIONS.CODE.CODE_2_WAY_MESSAGING,
            EXTENSIONS.CODE.CODE_SMS
        ]
    },
    {
        permissionKey: "report.schedule.pending_appointment",
        extensions: [EXTENSIONS.CODE.CODE_ONSCHEDULE]
    },
    {
        permissionKey: "setting.device.add",
        extensions: [EXTENSIONS.CODE.CODE_GRAVITY]
    },
    {
        permissionKey: "setting.device.delete",
        extensions: [EXTENSIONS.CODE.CODE_GRAVITY]
    }
];

export default {
    components: {},
    props: {
        permission: {
            type: Object,
            default: null
        },
        updatePermission: {
            type: Function
        }
    },
    data() {
        return {
            isHidden: false
        };
    },
    created() {
        if (this.permission) {
            this.checkIfDependingOnExtensions();
        }
    },
    methods: {
        onPermissionToggled() {
            if (this.permission) {
                this.permission.access = !this.permission.access ? 1 : 0;
                this.updatePermission(this.permission);
            }
        },
        checkIfDependingOnExtensions() {
            const extensionsDependentPermission = EXTENSIONS_DEPENDENT_PERMISSSIONS.find(
                p => p.permissionKey === this.permission.key
            );

            if (extensionsDependentPermission) {
                const isExtensionsEnabled = () => {
                    for (const extenstion of extensionsDependentPermission.extensions) {
                        if (this._isExtensionEnabled(extenstion)) {
                            return true;
                        }
                    }

                    return false;
                };

                this.isHidden = !isExtensionsEnabled();
            }
        }
    }
};
</script>
